import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

type CityStoreType = {
    isGetUserLocation: boolean;
    setIsGetUserLocation: (isLocation: boolean) => void;
    cityId: number;
    cityLocation: [number, number];
    setCityId: (cityId: number, cityLocation?: [number, number]) => void;
    setCityLocation: (cityLocation: [number, number]) => void;
};

export const useCityStore = create<CityStoreType>()(
    immer((set) => ({
        cityId: 1,
        cityLocation: [35.6892, 51.389],
        isGetUserLocation: false,
        setCityId: (cityId: number, cityLocation?: [number, number]) =>
            set((state) => {
                state.cityId = cityId;
                if (cityLocation) {
                    state.cityLocation = cityLocation;
                }
            }),
        setCityLocation: (cityLocation) =>
            set((state) => {
                state.cityLocation = cityLocation;
            }),
        setIsGetUserLocation: (value) =>
            set((state) => {
                state.isGetUserLocation = value;
            })
    }))
);
